import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import { Text } from 'components'
import { translate } from 'react-i18next'
import carImage from 'assets/images/car.svg'
import GameTemplate from '../templates/GameTemplate'
import './Loading.css'

@pageData({ title: 'Loading' })
@connect(state => ({
    phase: state.phaseInfo.phase
}))
@translate()
export class Loading extends PureComponent {
    render() {
        const { phase, t } = this.props
        return (
            <GameTemplate className="Loading">
                <div className="h-100 flex-grow flex col-center">
                    <img src={carImage} />
                    <Text className="Loading-Title">Loading...</Text>
                    <Text className="Loading-Text">{t(`game.${phase || 'UNKNOWN'}.loadingText`)}</Text>
                </div>
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Loading/Loading.js